module.exports = __webpack_public_path__ + "fonts/EuclidEnercity-LightItalic-WebS.8870e96f.eot";